export default __webpack_public_path__ + "static/media/google-play-icon.4536275b.webp";